// extracted by mini-css-extract-plugin
module.exports = {"hero":"rCwTiRTqcJcEl2KnFIh78w=="};